import PropTypes from 'prop-types';
export const mediabarBlogPropTypes = {
  /**
   *  Items to display as an Icon
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.object,
    picture: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    })
  })),
  /**
   * Link
   */
  href: PropTypes.string,
  /**
   * Link title
   */
  title: PropTypes.string,
  /**
   * Heading content
   */
  heading: PropTypes.string,
  /**
   * Additional classname
   */
  classname: PropTypes.string
};